import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.tenantProfileBroker.1";
import { IExtraData } from "./schema.tenantProfileBroker.types";
import { getInitialValues } from "./schema.tenantProfileBroker.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues),
      uiSchema: uiSchema1(extraData),
    },
  ];
};
